import { deleteCookie } from "cookies-next";
import { AUTH_COOKIE_NAME } from "../const";

/**
 * Clears the httpOnly auth-session cookie via the logout API,
 * and removes any legacy non-httpOnly client cookie.
 */
export default async function clearAuthCookie(): Promise<void> {
  try {
    await fetch("/api/auth/logout", { method: "POST" });
  } catch (error) {
    console.warn("[auth] logout API failed:", error);
  }

  deleteCookie(AUTH_COOKIE_NAME);
}
